import React, { FC } from 'react'

import { ReactComponent as SidebarRightIcon } from '@sketch/icons/sidebar-24-svg'
import { useForTablet } from '@sketch/components'

import { ToggleButton, Wrapper } from './HeaderSidebarToggle.styles'

type HeaderSidebarToggleProps = {
  isSidebarOpen: boolean
  toggleSidebar: () => void
}

export const HeaderSidebarToggle: FC<HeaderSidebarToggleProps> = ({
  toggleSidebar,
  isSidebarOpen,
}) => {
  const isTabletAndBigger = useForTablet()

  return (
    <Wrapper $expanded={isTabletAndBigger && isSidebarOpen}>
      <ToggleButton
        size={24}
        icon={SidebarRightIcon}
        onClick={toggleSidebar}
        data-testid="header-sidebar-toggle"
      />
    </Wrapper>
  )
}

export default HeaderSidebarToggle
